import SearchImage from '@assets/images/app/home-search.png';
import React from 'react';
import { MainFeedCellProps } from '.';

export const PopularKeywordsCell: React.FC<MainFeedCellProps> = (props) => {
  const { data } = props;

  const splitedKeywords = [];

  for (let i = 0; i < data.length; i += 3) {
    const chunk = data.slice(i, i + 3);
    splitedKeywords.push(chunk);
    if (splitedKeywords.length > 1) {
      break;
    }
  }

  return (
    <div id="keywords-cell" style={props.style}>
      <div
        style={{
          backgroundColor: 'white',
          fontSize: '19px',
          fontWeight: 'bold',
          color: '#242424',
        }}>
        {props.title || '실시간 인기 검색어 TOP 6'}
      </div>
      <div style={{ marginTop: '16px' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            gridTemplateRows: 'repeat(3, 1fr)',
            gap: '8px',
            width: '100%',
          }}>
          {[0, 3, 1, 4, 2, 5].map((orderIndex, index) => {
            const keyword = data[orderIndex];
            return (
              <button
                className="link-button"
                key={`keyword-child-${index}`}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  height: '40px',
                  padding: '0 12px',
                  borderRadius: '8px',
                  backgroundColor: '#f8f9fc',
                  minWidth: 0,
                }}
                onClick={() => {
                  props.onClick && props.onClick(keyword._id);
                }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    color: '#2d363d',
                    fontSize: '14px',
                    width: '100%',
                  }}>
                  <div
                    style={{
                      fontWeight: 'bold',
                      fontSize: '15px',
                      color: orderIndex < 3 ? '#ff5e5e' : '#424242',
                      marginRight: '8px',
                    }}>
                    {orderIndex + 1}
                  </div>
                  <div
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      flex: 1,
                    }}>
                    {keyword._id}
                  </div>
                  <div style={{ marginLeft: '8px' }}>
                    <img
                      style={{
                        height: 20,
                        width: 20,
                      }}
                      src={SearchImage}
                      alt=""
                    />
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PopularKeywordsCell;
